import { Link, useLocation, useNavigate } from "react-router-dom"
import AuthPage from "../../components/layout/authPage"
import { Col, VImage,Row } from "../../style/base.style"
import { doctorBanner, facebookIcon, googleIcon, loginBanner } from "../../constants/images"
import { useEffect, useState } from "react"
import { FormComponent } from "../../components/form"
import { FieldType, TextFieldType } from "../../components/fields"
import Joi from "joi"
import { useDictionary } from "../../contexts/dictionary"
import {  PhoneAuthNew } from "../../hooks/socialAuth"
import { useFormHandling } from "../../hooks/formUtils"
import { RequestConfigs } from "../../api"
import { ActionButton } from "../../components/buttons/ActionButton"
import { Colors } from "../../style/colors"
import { VerticalSepWithTitle } from "../../components/common/verticalSepWithTitle"
import { useContactType } from "../../contexts/ContactContext"
import { routesMap } from "../../constants/routes"




export const RegisterPhonePage = () => {

  const {translate} = useDictionary()

  const {getAuthNextPage} = useContactType()

  const navigate = useNavigate();

  const registerFields: FieldConfig[] = [
   
    {
      type: FieldType.text,
      name: "Phone",
      label: translate("phone_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },
   
  ]








  const [combineServerRes, setCombineServerRes] = useState<ApiResponse | null>(null);



  
  const {handleInputChange, handleClick, serverRes,formValues} = useFormHandling({requestType:RequestConfigs.updateContact})
  const {addPhoneAuth} = PhoneAuthNew()


   const processPhoneAuth = async (phone:string) => {
     const phoneRes = await addPhoneAuth(phone)
     if(!phoneRes.succeeded){
       setCombineServerRes(phoneRes as ApiResponse)
     } else {
       navigate( routesMap.otpRegister.to+'?verificationId='+phoneRes.verificationId)
     }
   }

  useEffect(() => {
    if (serverRes) {
      setCombineServerRes(serverRes);
    }
    if(serverRes?.succeeded){
      if(process.env.REACT_APP_PHONE_AUTH === 'yes'){
        processPhoneAuth(formValues.Phone)
      } else {
        const nextpage = getAuthNextPage()
        navigate(nextpage || '/dashboard')
      }
    
    }
  }, [serverRes]);

  useEffect(() => {
    if (combineServerRes) {
      if(combineServerRes.verificationId){
        navigate('/otp-phone?verificationId='+combineServerRes.verificationId)
      }
    }
  }, [combineServerRes]);

  

    return (
      <AuthPage>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <Col>
                {/* Login Tab Content */}
                <div className="contact-content">
                  <div className="row align-items-center justify-content-center">
                    <Col $width="40%">
                      <VImage
                        src={doctorBanner}
                        className="img-fluid"
                        alt="Doccure Login"
                      />
                    </Col>
                    <Col style={{maxWidth:'500px'}} $width="60%" $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $backgroundColor={Colors.whiteBackground} $gap={10} $padding="80px 20px">
                     <FormComponent 
                      fields={registerFields}
                      title={translate("update_phone")}
                      onChange={handleInputChange}
                      serverRes={combineServerRes}
                     />
                     <ActionButton width="100%" onClick={()=>{handleClick()}} label={translate('submit')} />
                
                      
                     
                      
                    </Col>
                  </div>
                </div>
                {/* /Login Tab Content */}
              </Col>
            </div>
          </div>
        </div>
      </AuthPage>
        
    )

}